import styles from "./PillButton.module.css";

const PillButton = ({
  size = "md",
  type = "button",
  className = "",
  pressed = false,
  children,
  ...rest
}) => (
  <button
    type={type}
    aria-pressed={pressed}
    className={[
      styles.root,
      styles[size],
      pressed ? styles.pressed : "",
      className,
    ]
      .filter(Boolean)
      .join(" ")}
    {...rest}
  >
    {children}
  </button>
);

export default PillButton;
